module.exports = __webpack_public_path__ + "img/hbs-banner.9a04a303.png";